import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function ChecklistIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "34"}
      height={height || "34"}
      viewBox="0 0 34 34"
    >
      <rect
        id="Rectangle_1930"
        data-name="Rectangle 1930"
        width="34"
        height="34"
        rx="5"
        fill="#f9f9f9"
      />
      <path
        id="Path_10393"
        data-name="Path 10393"
        d="M8.266-10.609a4,4,0,0,0-4-4,4,4,0,0,0-4,4,4,4,0,0,0,4,4A4,4,0,0,0,8.266-10.609ZM3.8-8.491a.258.258,0,0,1-.365,0L1.761-10.169a.258.258,0,0,1,0-.365l.365-.365a.258.258,0,0,1,.365,0l1.13,1.13,2.42-2.42a.258.258,0,0,1,.365,0l.365.365a.258.258,0,0,1,0,.365Z"
        transform="translate(5.734 22.609)"
        fill="#707070"
      />
      <path
        id="Subtraction_13"
        data-name="Subtraction 13"
        d="M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,1.5A2.5,2.5,0,1,0,6.5,4,2.5,2.5,0,0,0,4,1.5Z"
        transform="translate(6 18)"
        fill="#707070"
      />
      <rect
        id="Rectangle_1913"
        data-name="Rectangle 1913"
        width="12"
        height="1.75"
        rx="0.5"
        transform="translate(16 11)"
        fill="#707070"
      />
      <rect
        id="Rectangle_1914"
        data-name="Rectangle 1914"
        width="12"
        height="1.75"
        rx="0.5"
        transform="translate(16 21)"
        fill="#707070"
      />
    </svg>
  );
}
